import React, { useState } from "react";
import { Box, Flex } from "rebass";
import { useSelector } from "react-redux";
import ErrorBonduary from "../ErrorBonduary";

const Price = (props) => {
  const {
    price: priceProp,
    currency,
    style,
    sx,
    hideCurrency,
    previousText,
    nextText,
  } = props;
  const price = priceProp || 0;
  const { customer } = useSelector((state) => state.yodaCustomer);
  const { hidePrice } = useSelector((state) => state.system);

  const getCurrency = () => {
    const curr = currency || customer.currencyCode;

    const currDic = {
      EUR: "\u20AC",
      USD: "\u0024",
    };
    return currDic[curr] || curr;
  };

  return (
    <ErrorBonduary
      disableLogs
      fallback={
        <Flex
          style={style}
          sx={{
            whiteSpace: "nowrap",
            gap: "4px",
            ...sx,
          }}
          alignItems="center"
        >
          <Box>{previousText}</Box>
          <Box>
            {(currency || customer?.currencyCode) &&
            !hidePrice &&
            !isNaN(parseFloat(price))
              ? `${Number(price).toFixed(2)}${
                  !hideCurrency ? ` ${getCurrency()}` : ""
                }`
              : ""}
            {hidePrice && "*****"}
          </Box>
          <Box>{nextText}</Box>
        </Flex>
      }
    >
      <FormattedPrice {...props} {...{ customer, hidePrice }} />
    </ErrorBonduary>
  );
};

const FormattedPrice = ({
  price: priceProp,
  currency,
  style,
  sx,
  hideCurrency,
  previousText,
  nextText,
  negativeAsColor,
  absoluteNumber,
  customer,
  hidePrice,
}) => {
  const price = priceProp || 0;
  const [isNegative, setIsNegative] = useState(false);

  function tryHideCurrency(value) {
    let negativeNumber = value.filter((x) => x.type == "minusSign");
    if (negativeNumber.length > 0) {
      if (!isNegative) {
        setIsNegative(true);
      }
    } else {
      if (isNegative) {
        setIsNegative(false);
      }
    }
    if (negativeAsColor == true || absoluteNumber == true) {
      value = value.filter((x) => x.type !== "minusSign");
    }

    if (hideCurrency === true) {
      return (
        (previousText ? "" : "") +
        value
          .filter((x) => x.type !== "currency")
          .map((x) => x.value)
          .join("")
          .trim() +
        (nextText ? "" : "")
      );
    }
    return (
      (previousText ? "" : "") +
      value
        .map((x) => x.value)
        .join("")
        .trim() +
      (nextText ? "" : "")
    );
  }
  return (
    <Flex
      style={style}
      color={isNegative && negativeAsColor ? "red!important" : ""}
      sx={sx}
      alignItems="center"
    >
      {previousText}
      {(currency || customer?.currencyCode) &&
        !hidePrice &&
        tryHideCurrency(
          new Intl.NumberFormat("it-IT", {
            style: "currency",
            currency: currency || customer.currencyCode,
            currencyDisplay: "symbol",
          }).formatToParts(price),
        )}
      {hidePrice && "*****"}
      {nextText}
    </Flex>
  );
};

export { Price };
